/**
 * Всегда возвращать массив
 * @param target Значение, на основе которого будет получен массив
 * @returns Массив на основе `target`
 *
 * @remarks Если `target` является массивом, то вернется его копия
 */
export const getAlwaysArray = <T>(target: T | T[]) => [target].flat();
